import { render, staticRenderFns } from "./edit1.vue?vue&type=template&id=479fd43c&scoped=true"
import script from "./edit1.vue?vue&type=script&lang=js"
export * from "./edit1.vue?vue&type=script&lang=js"
import style0 from "./edit1.vue?vue&type=style&index=0&id=479fd43c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479fd43c",
  null
  
)

export default component.exports